export default "__VITE_ASSET__CwwuB5Gp__"